import * as React from 'react';

export interface ErrorProps {
    logo: string;
    message: string;
    title: string;
}

export default class Error extends React.Component<ErrorProps> {
    render() {
        const {
            logo,
            message,
            title,
        } = this.props;

        return (
            <section className='mt-doc-tools__progress ms-u-fadeIn500'>
                <img width='90' height='90' src={logo} alt={title} title={title} />
                <h1 className='ms-fontSize-su ms-fontWeight-light ms-fontColor-neutralPrimary'>{title}</h1>
                An error occurred:<br/> 
                {message}                
            </section>
        );
    }
}



// WEBPACK FOOTER //
// ./components/Error.tsx